import React from 'react';

const ScrollToTop: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <a href="#" className="scrollToTop scroll-btn" onClick={handleClick}>
      <i className="far fa-arrow-up"></i>
    </a>
  );
};

export default ScrollToTop;
